module.exports = __webpack_public_path__ + "media/images/common/order_btn_l-0755cee4a524a4cbabc1162a7f364b8c.png";